/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: subscriptions-resource-factory.js
 *
 * Created by randysorensen on 5/25/17.
 */

'use strict';

angular
.module('prism-ui.components.data')
.factory('SubscriptionsResourceFactory',

function ($resource, EndPointService) {
	return $resource(EndPointService.partnerEndPoint, {}, {
		'getSubscriptions': {
			method: 'GET',
			url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions',
			params: {
				id: '@partnerId'
			},
			isArray: true
		},
		'getSubscriptionsFiltered': {
			method: 'POST',
			url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/searches',
			params: {
				partnerId: '@partnerId'
			},
			isArray: true,
		},
		'getSubscription': {
			method: 'GET',
			url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/:subId',
			params: {
				partnerId: '@partnerId',
				subId: '@subId'
			},
			isArray: false
		},
		'createSubscription': {
			method: 'POST',
			url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions',
			params: {
				partnerId: '@partnerId'
			},
			isArray: false
		},
		'saveSubscription': {
			method: 'PUT',
			url: EndPointService.partnerEndPoint + '/:partnerId/subscriptions/:subId',
			params: {
				partnerId: '@partnerId',
				subId: '@subId'
			},
			isArray: false
		},
		'saveSubscriptions': {
			method: 'POST',
			url: EndPointService.partnerEndPoint + '/subscriptions',
			isArray: true
		},
		'getSubscriptionsByContentCategory': {
			method: 'GET',
			url: EndPointService.partnerEndPoint + '/subscriptions/:contentId/:categoryId',
			params: {
				contentId: '@contentId',
				categoryId: '@categoryId'
			},
			isArray: true
		},
        'getSubscriptionsByContentCategoryFiltered': {
            method: 'POST',
            url: EndPointService.partnerEndPoint + '/subscriptions/:contentId/:categoryId/searches',
            params: {
                contentId: '@contentId',
                categoryId: '@categoryId'
            },
            isArray: true
        },
	});

});
